import {Box} from '@mui/material';
import {t} from 'i18next';
import {ReactComponent as ArrowForward} from '../../../../../assests/svg/arrow-forward.svg';
import {ReactComponent as ArrowForwardInactive} from '../../../../../assests/svg/arrow-forward-inactive.svg';
import {ReactComponent as ArrowBackwardInactive} from '../../../../../assests/svg/arrow-backward-inactive.svg';
import {ReactComponent as ArrowBackward} from '../../../../../assests/svg/arrow-backward.svg';
import AurIconButton from '../../../../common/aur-button/AurIconButton';
import {TermData} from './AurSlateEditor';
import {useAnalytics} from '../../../../../hooks/useAnalytics';
import {
  GA_CLICK_TYPES,
  GA_EVENT_NAMES,
  GA_REGIONS,
  GA_SUBPAGE_TYPE,
} from '../../../../../constants/analyticsConstants';

interface TermsContentMiddleProps {
  terms: TermData[];
  selectedRows: (string | number)[];
  moveTermsToRight: (
    isAPICalled: boolean,
    shouldAddErrorTerms: boolean
  ) => void;
  moveTermsToLeft: () => void;
  isTermHighlighted: boolean;
}

const TermsContentMiddle: React.FC<TermsContentMiddleProps> = ({
  terms,
  selectedRows,
  moveTermsToRight,
  moveTermsToLeft,
}) => {
  const {trackGAEvent} = useAnalytics();

  const isProcessDisabled =
    terms.length <= 0 ||
    !terms.some(
      (term) => term.isAPIErrorTerm === true || term.isDuplicateTerm !== true
    );
  return (
    <Box
      className="terms-content-panels-middle"
      data-test-id="terms-content-middle"
    >
      <div className="terms-content-panels-middle-buttons">
        <AurIconButton
          className="action-button"
          icon={
            isProcessDisabled ? <ArrowForwardInactive /> : <ArrowBackward />
          }
          onClick={() => {
            moveTermsToRight(false, false);
            trackGAEvent({
              eventName: GA_EVENT_NAMES.CLICK,
              click: {
                name: t('gaTracking.global.add'),
                type: GA_CLICK_TYPES.ICON,
                region: GA_REGIONS.TAB,
                action: t('gaTracking.str.termContentAction', {
                  action: t('gaTracking.global.added'),
                }),
              },
              subPage: {
                subpage_name: t('gaTracking.str.addTerms'),
                subpage_type: GA_SUBPAGE_TYPE.TAB,
              },
            });
          }}
          size="big"
          disabled={isProcessDisabled}
          ariaLabel={t('eca.searchTermReport.termsContent.forward')}
          dataTestId={t('eca.searchTermReport.termsContent.forward')}
        />
        <AurIconButton
          className="action-button"
          icon={
            selectedRows.length > 0 ? (
              <ArrowForward aria-hidden="true" />
            ) : (
              <ArrowBackwardInactive aria-hidden="true" />
            )
          }
          onClick={() => {
            moveTermsToLeft();
            trackGAEvent({
              eventName: GA_EVENT_NAMES.CLICK,
              click: {
                name: t('gaTracking.global.remove'),
                type: GA_CLICK_TYPES.ICON,
                region: GA_REGIONS.TAB,
                action: t('gaTracking.str.termContentAction', {
                  action: t('gaTracking.global.removed'),
                }),
              },
              subPage: {
                subpage_name: t('gaTracking.str.addTerms'),
                subpage_type: GA_SUBPAGE_TYPE.TAB,
              },
            });
          }}
          size="big"
          disabled={selectedRows?.length <= 0}
          ariaLabel={t('eca.searchTermReport.termsContent.backward')}
          dataTestId={t('eca.searchTermReport.termsContent.backward')}
        />
      </div>
    </Box>
  );
};

export default TermsContentMiddle;
